<template>
  <div
    :class="['theme-radio__field-holder',
    {
      'theme-radio__field-holder--error': !!errors.has(newName),
    }]"
    data-vv-value-path="model"
    :data-vv-as="label ? label : validationLabel"
  >
    <label class="theme-input__label mb-4" v-if="label && !hideLabel">
      {{ label }}
      <span v-if="isRequired" class="theme-input__label-asterisk">*</span>
    </label>
    <input type="hidden" :name="name" v-model="model" v-validate="rules" />
    <div
      :class="['theme-radio',
      {
        'theme-radio--is-dirty': isDirty,
        'theme-radio--is-disabled': disabled,
        'theme-radio--has-label': Object.keys(options).length || this.$slots.default,
        'theme-radio--column-direction': columnDirection,
      }]"
    >
      <label
        :for="name + key"
        class="theme-radio__item theme-radio__item--is-radio"
        v-for="(option, key) in options"
        :key="key"
        @click.prevent="stateChange($event)"
      >
        <input
          :name="name"
          type="radio"
          :value="key"
          v-model="model"
          :disabled="disabled"
          :id="name + key"
        />
        <div class="theme-radio__indicator"/>
        <span v-html="option"></span>
      </label>
    </div>
  </div>

</template>

<script>
import field from "../admin/mixins/field";

export default {
  computed: {
    isDirty() {
      return !!this.model;
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  mixins: [field],
  methods: {
    stateChange(event) {
      if(!this.disabled){
        var innerInputValue =
          event.target.tagName == "LABEL"
            ? event.target.getElementsByTagName("input")[0].value
            : event.target.parentElement.getElementsByTagName("input")[0].value;

        this.model =
          this.model === innerInputValue
            ? innerInputValue === 0
              ? innerInputValue
              : null
            : innerInputValue;
      }
    },
    // disableAutoComplete() {
    //   let elements = document.querySelectorAll('[autocomplete="off"]');

    //   if (!elements) {
    //     return;
    //   }

    //   [...elements].forEach((element) => {
    //     element.setAttribute("readonly", "readonly");

    //     setTimeout(() => {
    //       element.removeAttribute("readonly");
    //     }, 500);
    //   });
    // },
    // sortProperties(obj, sortBy, order) {
    //   var sortable = [];
    //   for (var key in obj) {
    //     if (obj.hasOwnProperty(key)) {
    //       sortable.push([key, obj[key]]);
    //     }
    //   }
    //   if (sortBy == "key") {
    //     sortable.sort(function (a, b) {
    //       var x = parseInt(a[0]),
    //         y = parseInt(b[0]);
    //       return order == "desc"
    //         ? x > y
    //           ? -1
    //           : x < y
    //           ? 1
    //           : 0
    //         : x < y
    //         ? -1
    //         : x > y
    //         ? 1
    //         : 0;
    //     });
    //   } else if (sortBy == "custom") {
    //     sortable = this.customOrder;
    //   } else {
    //     sortable.sort(function (a, b) {
    //       var x = a[1].toLowerCase(),
    //         y = b[1].toLowerCase();
    //       return order == "desc"
    //         ? x > y
    //           ? -1
    //           : x < y
    //           ? 1
    //           : 0
    //         : x < y
    //         ? -1
    //         : x > y
    //         ? 1
    //         : 0;
    //     });
    //   }
    //   return sortable;
    // },

  },
  props: {
    label: {
      default() {
        return "";
      },
      type: String,
    },
    validationLabel: {
      default: "",
      type: String,
    },
    options: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    value: {
      default: null,
      type: [Number, String, Array],
    },
    // extraStylingIsEnabled: {
    //   default: false,
    //   type: Boolean,
    // },
    sort: {
      default: false,
      type: Boolean,
    },
    sortBy: {
      default: "key",
      type: String,
    },
    order: {
      default: "asc",
      type: String,
    },
    customOrder: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    columnDirection: {
      default: false,
      type: Boolean,
    },
    isRequired: {
        default: false,
        type: Boolean,
      },
    hideLabel: {
      default: false,
      type: Boolean,
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/components/ThemeRadios.vue